import { render } from "./dentrion_benefit.vue?vue&type=template&id=74a19dfd&scoped=true"
import script from "./dentrion_benefit.vue?vue&type=script&lang=js"
export * from "./dentrion_benefit.vue?vue&type=script&lang=js"

import "./dentrion_benefit.vue?vue&type=style&index=0&id=74a19dfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a19dfd"]])

export default __exports__